// extracted by mini-css-extract-plugin
export default {"manage":"Y6dUs71GHsjw_qvWxoDG","summary":"RFIdlQ39vCAh1WaT3djQ","haltedIcon":"tZ5NstfgN1xylfgHy2y5"};